import { NEW_PASSWORD_MIN_LENGTH, language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOU_HAVE_SELECTED: "Du har valgt",
      DINNERS_FOR: "middager for",
      AMOUNT_OF_PEOPLE: "personer per uke",
      YOUR_ACCOUNT_GIVES_ACCESS_TO: (dishCount: number) =>
        `Din konto gir deg tilgang til din personlige meny ${dishCount} retter hver uke!`,
      CREATE_ACCOUNT: "Opprett konto",
      EMAIL_PLACEHOLDER_TEXT: "E-postadresse",
      EMAIL_ERROR_MESSAGE: "E-postadresse er ikke gyldig",
      EMAIL_REQUIRED_MESSAGE: "E-post kreves",
      PASSWORD_PLACEHOLDER_TEXT: "Velg passord",
      PASSWORD_REQUIRED_MESSAGE: "Passord påkrevd",
      PASSWORD_ERROR_MESSAGE: `Passordet ditt må inneholde minst ${NEW_PASSWORD_MIN_LENGTH} tegn`,
      CHECKBOX_TEXT: "Ja, send meg e-post med tilbud og konkurranser.",
      SUBMIT_BUTTON: "Gå videre",
      ROUTER_PATH: "addresse",
    },
    se: {
      YOU_HAVE_SELECTED: "Du har valt",
      DINNERS_FOR: "middagar för",
      AMOUNT_OF_PEOPLE: "personer per vecka",
      YOUR_ACCOUNT_GIVES_ACCESS_TO: (dishCount: number) =>
        `Ditt konto ger dig tillgång till din personliga meny och ${dishCount} rätter varje vecka!`,
      CREATE_ACCOUNT: "Skapa konto",
      EMAIL_PLACEHOLDER_TEXT: "E-postadress",
      EMAIL_ERROR_MESSAGE: "Uppge en giltig e-postadress",
      EMAIL_REQUIRED_MESSAGE: "Epost krävs",
      PASSWORD_PLACEHOLDER_TEXT: "Välj lösenord",
      PASSWORD_REQUIRED_MESSAGE: "Lösenord krävs",
      PASSWORD_ERROR_MESSAGE: `Ditt lösenord måste som minst innehålla ${NEW_PASSWORD_MIN_LENGTH} tecken`,
      CHECKBOX_TEXT: "Ja tack, maila mig erbjudanden och tävlingar.",
      SUBMIT_BUTTON: "Gå vidare",
      ROUTER_PATH: "adress",
    },

    dk: {
      YOU_HAVE_SELECTED: "Du har valgt",
      DINNERS_FOR: "retter til",
      AMOUNT_OF_PEOPLE: "personer per uge",
      YOUR_ACCOUNT_GIVES_ACCESS_TO: (dishCount: number) =>
        `Din konto giver dig adgang til din personlige menu ${dishCount} retter hver uge!`,
      CREATE_ACCOUNT: "Opret konto",
      EMAIL_PLACEHOLDER_TEXT: "E-mail",
      EMAIL_ERROR_MESSAGE: "Oppgi gyldig e-postadresse",
      EMAIL_REQUIRED_MESSAGE: "E-mail påkrævet",
      PASSWORD_PLACEHOLDER_TEXT: "Vælg password",
      PASSWORD_REQUIRED_MESSAGE: "Password påkrævet",
      PASSWORD_ERROR_MESSAGE: `Dit password skal mindst indeholde ${NEW_PASSWORD_MIN_LENGTH} tegn`,
      CHECKBOX_TEXT: "Ja, send mig en e-mail med tilbud og konkurrencer.",
      SUBMIT_BUTTON: "Gå videre",
      ROUTER_PATH: "adresse",
    },
  } as const
)[language];
